import { Component, OnInit, QueryList, ViewChild, ViewChildren, Inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { CommonService } from "src/app/Service/Common.service";
import { NotificationService } from "src/app/Service/notification.service";
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { EIPAutoCompleteComponent } from "eipauto-complete";
import { DynamicFormComponent } from "src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component";
import { FieldConfig } from "src/app/CommonComponents/dynamic-form/interface/field.interface";
import { ICPCDocOutputModel, IRevisionCategory, IScheduleBulkInsertModel, IScheduleDocDetails, IScheduleDocElementDetails, IScheduleDocModel, IScheduleDocRevModel, IScheduleDocStageDetails, IScheduleMHDetails, IScheduleStageId, IScheduleType, IScheduleWFPlanDetails, IScheduleWFPlanStageDetails, IScheduleWorkflowDetails, IWBSOutputModel, IScheduleISODocUploadDetailsModel, IScheduleDocUploadStatusModel } from "src/app/ViewModel/ScheduleDocumentModel";
import { ProjectInfoService } from "src/app/Service/project-info/project-info.service";
import { IProjectElementDetailsOutput, IProjectElementsOutput, IProjectFeatureOutput } from "src/app/ViewModel/ProjectElementsModel";
import { ScheduleDefinitionService } from "src/app/Service/scheduledefintion/scheduledefintion.service";
import { IDocSetModel, IScheduleElementDetails, IStageElementDetails } from "src/app/ViewModel/ScheduleDefinitionModel";
import { EIPAutoCompleteEventModel } from "src/app/ViewModel/EIPAutoCompleteEventModel";
import { ScheduleDocumentService } from "src/app/Service/scheduledocument/scheduleDocument.service";
import { Module } from "src/app/Service/element-details.data.service";
import { ProjectMasterService } from "src/app/Service/projectmaster/projectmaster.service";
import { IProjectMasterViewModel } from "src/app/ViewModel/ProjectMasterModel";
import { WorkflowTemplateModel } from "src/app/ViewModel/WorkflowTemplateModel";
import { BusinessGroupModel } from "src/app/ViewModel/BusinessGroupModel";
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { ScheduleExcelUploadComponent } from '../schedule-excel-upload/schedule-excel-upload.component';

interface IStageDates {
  minDate: Date,
  maxDate: Date,
  value: Date
}

@Component({
  selector: 'app-iso-dci-upload',
  templateUrl: './iso-dci-upload.component.html',
  styleUrls: ['./iso-dci-upload.component.css']
})
export class ISODCIUploadComponent implements OnInit {
  public projectId: number = 0;
  public groupId: number = 0;
  public memberId: number = 0;
  public CurrentProjectDetails!: ProjectViewModel;
  dciForm!: FormGroup;
  docScheduleForm!: FormGroup;
  revForm!: FormGroup;
  panelOpenState = true;
  inputRequiredOptions: any[] = [{ value: true, name: "Required" }, { value: false, name: "Not Required" }];
  schTypeOptions: IScheduleType[] = [{ schType_Id: 1, schType_Name: "DCI" }];
  projectElements: IProjectElementsOutput[] = [];
  projectStaticElements: IProjectElementsOutput[] = [];
  isAutoRevision: boolean = false;
  isDocSetRequired: boolean = true;
  isWBSIntegration: boolean = false;
  isAutoEnabled: boolean = true;
  IsDisabled: boolean = true;
  docSetList: IDocSetModel[] = [];
  docIndex: number = 0;
  WBSCode: string | null | undefined;
  wbsList: any = [];
  dvcodeList: any = [];
  JOBCode!: string;
  DeliverableCode: number | null | undefined;
  structPackEleId!: number;
  discEleId!: number;
  structSelectedDedId!: number;
  discSelectedDedId!: number;
  filteredDocSetList: IDocSetModel[] = [];
  selectedDocSet!: number;
  selectedDocSetStageDetails: IStageElementDetails[] = [];
  selectedDocSetStageDetailsCopy: IStageElementDetails[] = [];
  scheduleWFPlanStageDetails: IScheduleWFPlanStageDetails[] = [];
  stageDates: Map<string, IStageDates> = new Map<string, IStageDates>();
  workflowList: WorkflowTemplateModel[] = [];
  selectedWorkflow!: number;
  projBusinessGroups: BusinessGroupModel[] = [];
  selectedApprovalBy!: number;
  approverList: IProjectFeatureOutput[] = [];
  selectedAuthorisedBy!: number;
  elementsConfig: FieldConfig[] = [];
  numElements: Map<string, string> = new Map<string, string>();
  @ViewChild("docSetForm") dynamicForm!: DynamicFormComponent;
  @ViewChildren(EIPAutoCompleteComponent) eipAutoCompleteComponents!: QueryList<EIPAutoCompleteComponent>;
  revCategoryList: IRevisionCategory[] = [];
  selectedRevCategory!: number;
  ISOUploadedDocDetails: IScheduleISODocUploadDetailsModel[] = [];
  GridData: IScheduleISODocUploadDetailsModel[] = [];
  WTemplateStage: any = [];
  ProjectElementDetails!: IProjectElementDetailsOutput[];
  enableFullscreen = false;
  enableFilter = false;

  constructor(public dialogRef: MatDialogRef<ISODCIUploadComponent>, private _notificationService: NotificationService, private commonService: CommonService, private _formBuilder: FormBuilder, private _projService: ProjectInfoService, private _scheDefService: ScheduleDefinitionService, private _scheduleDocService: ScheduleDocumentService, private _projectService: ProjectMasterService, private _commonService: CommonService, private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public _data: IScheduleISODocUploadDetailsModel[], private loaderService: LoaderService) {
    this.createDCIForm();
  }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.CurrentProjectDetails = this.commonService.getCurrentProjectDetails();

    this.GridData = this._data;
    this.ISOUploadedDocDetails = JSON.parse(JSON.stringify(this.GridData))

    this.getProjectStaticElements();
    this.GetProjectElementDetails();
    this.copyGeneralDetails();
    this.getStructureDiscElementId();
    this.getDynamicForm();
    this.getApproverList();
    this.getProjectBusinessGroups();
    this.getWorkflowDetails();
    this.getRevisionCategories();
    this.dciForm.get('inputRequired')?.setValue(this.inputRequiredOptions[1]);
    this.dciForm.get('schType')?.setValue(this.schTypeOptions[0]);
    this.getWBSCodes();
  }



  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }

  GetProjectElementDetails() {
    this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.ScheduleDocument })
      .subscribe(async (res: IProjectElementDetailsOutput[]) => {
        if (res.length > 0) {
          this.ProjectElementDetails = res;
          await this.ISOUploadedDocDetails.forEach(async x => {
            this.getElementDetails("Print Size", x);
            this.getElementDetails("Status", x);
          });
          await this.ISOUploadedDocDetails.map(t => { return t.status = (t.errors && t.errors.length == 0) });
          this.GridData.map(itm => { return itm.errors = this.ISOUploadedDocDetails.find((item) => (item.rowNo == itm.rowNo))?.errors, itm.status = this.ISOUploadedDocDetails.find((item) => (item.rowNo == itm.rowNo))?.status });
        }
      }, (err: any) => { });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  numberOnly(event: { which: any; keyCode: any; }, field: string): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (['weightage', 'enggMH', 'draftMH'].includes(field)) {
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
        return false;
      } else {
        return true;
      }
    } else {
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      } else {
        return true;
      }
    }
  }

  getRevisionCategories() {
    this.revCategoryList = [{ revCategoryId: 1, revCategory: 'Minor' }, { revCategoryId: 2, revCategory: 'Major' }, { revCategoryId: 3, revCategory: 'First Release' }];
    let revisionCategory: IRevisionCategory = this.dciForm.get('revCategory')?.value;
    if (!!revisionCategory) {
      this.selectedRevCategory = revisionCategory.revCategoryId;
      this.setFormValue(this.revForm, "formrevCategory", revisionCategory.revCategory);
    }
  }

  /**
   * Get ApproverList
   */
  public getApproverList() {
    this._projService.getProjectFeatureWiseMembers({ projectId: this.projectId, groupId: this.groupId, featureDescription: 'Approve' })
      .subscribe((res: IProjectFeatureOutput[]) => {
        this.approverList = res;
        let approver: IProjectFeatureOutput = this.revForm.get('authorisedBy')?.value;
        if (!!approver) {
          this.selectedAuthorisedBy = approver.memberId;
          this.setFormValue(this.revForm, "formAuthorisedBy", this.selectedAuthorisedBy);
        }
      }, (err: any) => { });
  }

  /**
   * Load document set list
   */
  getDocSetList() {
    this._scheDefService.getDocSetList({ project_Id: this.projectId, group_Id: this.groupId }).subscribe((res: IDocSetModel[]) => {
      this.docSetList = res;
    });
  }

  private getStructureDiscElementId() {
    this._projService.getProjectElementIdByDescription('Structure / Package').subscribe((x: any) => {
      this.structPackEleId = x.deId;
    });
    this._projService.getProjectElementIdByDescription('Discipline').subscribe((x: any) => {
      this.discEleId = x.deId;
    });
  }

  setFormValue(form: FormGroup, formControlName: string, value: any) {
    form.get(formControlName)?.setValue(value);
  }

  private filterDocSet(elementDetail: IProjectElementDetailsOutput) {
    if (elementDetail.deId == this.structPackEleId)
      this.structSelectedDedId = elementDetail.dedId;
    else if (elementDetail.deId == this.discEleId)
      this.discSelectedDedId = elementDetail.dedId;
    //reset the last selected document set
    this.selectedDocSetStageDetails = [];
    this.selectedDocSetStageDetailsCopy = [];
    this.scheduleWFPlanStageDetails = [];
    this.stageDates.clear();
    this.filteredDocSetList = this.docSetList.filter(ds => ds.structure_DED_Id == this.structSelectedDedId &&
      ds.disc_DED_Id == this.discSelectedDedId);
    //if (!!this.sourceDciComponent) {
    let docSet: IDocSetModel = this.docScheduleForm.get('docSet')?.value;
    if (!!docSet) {
      if (docSet.doc_Set_Id)
        this.selectedDocSet = docSet.doc_Set_Id;
      this.setFormValue(this.docScheduleForm, "formDocSet", this.selectedDocSet);
      // }
    }
  }

  async getProjectStaticElements() {
    await this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.ScheduleDocument, IsQueryForStaticElement: true }).toPromise().then(
      (res: IProjectElementsOutput[]) => {
        if (res.length > 0) {
          this.projectStaticElements = res;
          let revElement: IProjectElementsOutput[] = this.projectStaticElements.filter(x => x.elementDescription == "Auto Revision");
          if (revElement.length > 0) {
            this.isAutoRevision = revElement[0].isDefaultSelect;
          }
          let isDocSetRequiredElement = this.projectStaticElements.filter(x => x.elementDescription == "IsDocSetRequired")[0];
          if (!!isDocSetRequiredElement) {
            this.isDocSetRequired = isDocSetRequiredElement.isMandatory;
            if (!this.isDocSetRequired) {
              this.IsDisabled = false;
            }
          }

          let isWBSIntegrationElement = this.projectStaticElements.filter(x => x.elementDescription == "WBS Integration")[0];
          if (!!isWBSIntegrationElement) {
            this.isWBSIntegration = isWBSIntegrationElement.isMandatory;
          }
        }
      }, (x: any) => {
        this._notificationService.showToast("failed to get static element details", "Warning");
      });
    if (this.isDocSetRequired)
      this.getDocSetList();
  }


  /**
  * Get Project business groups
  */
  getProjectBusinessGroups() {
    this._commonService.getProjectBusinessGroups(this._commonService.getProjectId()).subscribe((res: any) => {
      this.projBusinessGroups = res.filter((x: any) => x.is_Active);
      let businessGroup: BusinessGroupModel = this.docScheduleForm.get('approvalBy')?.value;
      if (!!businessGroup) {
        this.selectedApprovalBy = businessGroup.group_Id;
        this.setFormValue(this.docScheduleForm, "formApprovalBy", this.selectedApprovalBy);
      }
    });
  }

  getWorkflowDetails() {
    this._scheduleDocService.GetWorkflowList().subscribe((x: WorkflowTemplateModel[]) => {
      this.workflowList = x;
      let workflow: WorkflowTemplateModel = this.docScheduleForm.get('workflow')?.value;
      if (!!workflow) {
        this.selectedWorkflow = workflow.workflowId;
        this.setFormValue(this.docScheduleForm, "formWorkflow", this.selectedWorkflow);
      }
    })
  }

  createDCIForm() {
    this.dciForm = this._formBuilder.group({
      dciSerialNo: new FormControl({ value: '', disabled: true }),
      dciSemiNo: new FormControl({ value: '', disabled: true }),
      isConfidential: new FormControl(false),
      printSize: new FormControl(''),
      formPrintSize: new FormControl(''),
      title: new FormControl(''),
      enggManhours: new FormControl('', [Validators.pattern("^[0-9]*\.?[0-9]*$")]),
      draftingManHours: new FormControl('', [Validators.pattern("^[0-9]*\.?[0-9]*$")]),
      weightage: new FormControl('', Validators.pattern("^[0-9]*\.?[0-9]*$")),
      inputRequired: new FormControl('Required'),
      schType: new FormControl('DCI'),
      wbsCode: new FormControl(),
      dvCode: new FormControl()

    });
    this.docScheduleForm = this._formBuilder.group({
      approvalBy: new FormControl('', Validators.required),
      formApprovalBy: new FormControl('', Validators.required),
      workflow: new FormControl('', Validators.required),
      formWorkflow: new FormControl('', Validators.required),
      docSet: new FormControl('', Validators.required),
      formDocSet: new FormControl('', Validators.required),
      comments: new FormControl()
    });
    this.revForm = this._formBuilder.group({
      dciStatus: new FormControl(''),
      formDciStatus: new FormControl(''),
      revision: new FormControl({ value: '', disabled: true }),
      authorisedBy: new FormControl('', [Validators.required]),
      formAuthorisedBy: new FormControl('', [Validators.required]),
      qrCodeTag: new FormControl(true),
      reference: new FormControl(),
      noOfSheets: new FormControl(),
      revCategory: new FormControl('', Validators.required),
      formrevCategory: new FormControl('', Validators.required),
    });
  }

  getDynamicForm() {
    this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.ScheduleDocument, IsQueryForStaticElement: false }).subscribe(
      (res: IProjectElementsOutput[]) => {
        this.projectElements = res;


        this.elementsConfig = res.filter(s => { return s.isNumbering == false }).map(x => {
          let field: FieldConfig;
          let childDEId = null;
          let childDEDescription = "";
          let data = res.filter(item => item.dependentElementId == x.elementId);

          if (data.length > 0) {
            childDEId = data[0].elementId;
            childDEDescription = data[0].elementDescription;
          }

          field = {
            de_id: x.elementId,
            module_id: Module.ScheduleDocument,
            dependent_de_id: x.dependentElementId,
            dependent_de_Description: x.dependentElementDescription,
            child_de_id: childDEId,
            child_de_Description: childDEDescription,
            name: x.elementDescription,
            deDescription: x.elementDescription,
            type: 'select',
          }
          if (x.isMandatory) {
            field.validations = [
              {
                name: "required",
                validator: Validators.required,
                message: field.name + " Required"
              }
            ]
          }
          if (x.isNumbering) {
            this.numElements.set(x.elementDescription, '');
          }
          return field;
        });
        this.dynamicForm.fields = this.elementsConfig;
        this.dynamicForm.createControl();
        this.buildScheduleDocumentNumber();
        this.onCascadingAutocomplete_Change();
        this.loadWorkflowStages();
        this.copyElementDetailsFromSource();
      });
  }

  onCascadingAutocomplete_Change() {
    this.elementsConfig.forEach(data => {
      if (!!data.child_de_id && data.deDescription) {
        this.dynamicForm.form.get(data.deDescription)?.valueChanges.subscribe((x: any) => {
          let resForm: FormGroup = this.dynamicForm.value;
          let _field = this.dynamicForm.getCascadingAutocompleteDetails(data.child_de_Description);
          if (data.deDescription) {
            let parentControlSelectedValue: IProjectElementDetailsOutput = resForm.get(data.deDescription)?.value;

            if (_field.length > 0 && !!parentControlSelectedValue) {
              this._projService.getProjectElementCascadingDetails({
                projectId: this.projectId,
                groupId: this.groupId,
                moduleId: Module.ScheduleDocument,
                deId: _field[0].de_id,
                deDescription: _field[0].deDescription,
                dependentDEId: _field[0].dependent_de_id,
                dependentDEDId: parentControlSelectedValue.dedId
              }).subscribe((res: IProjectElementDetailsOutput[]) => {
                if (res.length > 0) {
                  res.map(val => val.displayText = (val.dedShortDescription!! && val.dedShortDescription.trim().length > 0 ? (val.dedShortDescription + " - ") : "") + val.dedDescription);
                  _field[0].values = res;
                }
                else {
                  _field[0].values = [];
                }
              }, (err: any) => { });
            }
            else {
              _field[0].values = [];
            }
          }
        })
      }
    })
  }

  private async loadWorkflowStages() {
    this.docScheduleForm.get('workflow')?.valueChanges.subscribe(async (res: WorkflowTemplateModel) => {
      if (!!res) {
        await this._scheduleDocService.GetWorkflowStageDetails({ project_Id: res.projectId, workflow_Id: res.workflowId }).toPromise().then((stages: IStageElementDetails[]) => {
          this.selectedDocSetStageDetails = [];
          this.scheduleWFPlanStageDetails = [];
          this.stageDates.clear();
          this.selectedDocSetStageDetails = stages.filter(x => x.is_Active == true);
          //stage_Short_Description
          this.selectedDocSetStageDetails.forEach(x => {
            let stageDate: IStageDates = { minDate: new Date(x.start_Date), maxDate: new Date(x.end_Date), value: new Date(x.end_Date) };
            if (x.stage_Id)
              this.stageDates.set(x.stage_Id.toString(), stageDate);

          });
          this.selectedDocSetStageDetailsCopy = this.selectedDocSetStageDetails;
        })
      }
    })
  }

  private copyElementDetailsFromSource() {
    let sourceProjElementForm: FormGroup = this.dynamicForm.value;
    this.projectElements.filter(s => { return s.isNumbering == false }).forEach(x => {
      let selectedValue: IProjectElementDetailsOutput = sourceProjElementForm.get(x.elementDescription)?.value;
      if (!!selectedValue) {
        let field: any = this.elementsConfig.find(ele => ele.de_id == selectedValue.deId && ele.deDescription == selectedValue.deDescription);
        if (!!field) {
          field.value.next(selectedValue.dedId);
        }
      }
    })
  }

  private subscribeDiscStructureChanges() {
    let resForm: FormGroup = this.dynamicForm.value;
    let structDiscFields: FieldConfig[] = this.elementsConfig.filter(x => x.de_id == this.discEleId || x.de_id == this.structPackEleId);
    structDiscFields.forEach(element => {
      if (element.deDescription)
        resForm.get(element.deDescription)?.valueChanges.subscribe((x: IProjectElementDetailsOutput) => {
          if (!!x)
            this.filterDocSet(x);
        })
    })
  }

  private loadStages() {
    this.docScheduleForm.get('docSet')?.valueChanges.subscribe((res: IDocSetModel) => {
      if (!!res) {
        //reset the last selected document set
        this.selectedDocSetStageDetails = [];
        this.selectedDocSetStageDetailsCopy = [];
        this.scheduleWFPlanStageDetails = [];
        this.stageDates.clear();
        this.selectedDocSetStageDetailsCopy = this.selectedDocSetStageDetails = res.stageDocumentSetDetails.filter(x => x.end_Date != null);

        if (this.WTemplateStage && this.WTemplateStage.length > 0) {
          let obj: IStageElementDetails[] = [];
          this.selectedDocSetStageDetails.forEach((val, index) => {
            if (this.WTemplateStage.some((x: number | undefined) => x == val.stage_Id))
              obj.push(val)
          });
          this.selectedDocSetStageDetailsCopy = this.selectedDocSetStageDetails = obj;
          this.revForm.get('revision')?.setValue('');
          if (this.selectedDocSetStageDetails && this.selectedDocSetStageDetails.length < 1)
            this._notificationService.showToast("Some mismatch in between the selected workflow and document set, please check corresponding configuration.", "Warning");
        }

        if (this.scheduleWFPlanStageDetails.length > 0) {
          this.scheduleWFPlanStageDetails.forEach(x => {
            let stageDetail = this.selectedDocSetStageDetails.filter(y => y.stage_Id == x.status_Id)[0];
            if (!!stageDetail) {
              stageDetail.checked = true;
              this.scheduleWFPlanStageDetails.push({ sort_By: x.sort_By, status_Id: x.status_Id, scheduled_On: x.scheduled_On });
            }
          })
        }
        this.selectedDocSetStageDetails.forEach(x => {
          if (x.end_Date != null) {
            let stageDate: IStageDates = {
              minDate: new Date(x.start_Date),
              maxDate: new Date(x.end_Date),
              value: new Date(x.end_Date)
            };
            if (x.stage_Id)
              this.stageDates.set(x.stage_Id.toString(), stageDate);

          }
        });
        this.selectedDocSetStageDetailsCopy = this.selectedDocSetStageDetails;
      }
    })
  }

  private buildScheduleDocumentNumber() {
    let resForm: FormGroup = this.dynamicForm.value;
    //Numbering elements array
    let numberingElements: string[] = Array.from(this.numElements.keys());
    numberingElements.forEach(element => {
      resForm.get(element)?.valueChanges.subscribe((x: IProjectElementDetailsOutput) => {

        if (this.numElements.has(element)) {
          if (!!x) {
            this.numElements.set(element, x.dedShortDescription);
          }
          else {
            this.numElements.set(element, '');
          }
        }
        if (this.isDocSetRequired && !!x) {
          if (x.deId == this.structPackEleId || x.deId == this.discEleId)
            this.filterDocSet(x);
        }
      });
    });
  }

  private copyGeneralDetails() {
    let sourceDciForm: FormGroup = this.dciForm;
    let sourceRevForm: FormGroup = this.revForm;
    let sourceDocScheduleForm: FormGroup = this.docScheduleForm;

    let enggManHours: number = sourceDciForm.get('enggManhours')?.value;
    if (!!enggManHours)
      this.dciForm.get('enggManhours')?.setValue(enggManHours);

    let draftingManHours: number = sourceDciForm.get('draftingManHours')?.value;
    if (!!draftingManHours)
      this.dciForm.get('draftingManHours')?.setValue(draftingManHours);

    let weightage: number = sourceDciForm.get('weightage')?.value;
    if (!!weightage)
      this.dciForm.get('weightage')?.setValue(weightage);

    let isConfidential: boolean = sourceDciForm.get('isConfidential')?.value;
    this.dciForm.get('isConfidential')?.setValue(isConfidential);

    let revision: string = sourceRevForm.get('revision')?.value;
    if (!!revision)
      this.revForm.get('revision')?.setValue(revision);

    let reference: string = sourceRevForm.get('reference')?.value;
    if (!!reference)
      this.revForm.get('reference')?.setValue(reference);

    let noOfSheets: number = sourceRevForm.get('noOfSheets')?.value;
    if (!!noOfSheets)
      this.revForm.get('noOfSheets')?.setValue(noOfSheets);

    let qrCodeTag: boolean = sourceRevForm.get('qrCodeTag')?.value;
    this.revForm.get('qrCodeTag')?.setValue(qrCodeTag);

    let comments: string = sourceDocScheduleForm.get('comments')?.value;
    if (!!comments)
      this.docScheduleForm.get('comments')?.setValue(comments);
  }

  onselectedValueChange(val: any, formGroupName: string, formControlName: string) {
    switch (formGroupName) {
      case "docScheduleForm":
        this.docScheduleForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
        break;
      case "dciForm":
        this.dciForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
        break;
      case "revForm":
        this.revForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
        break;
    }
    if (formControlName == 'workflow') {
      if (val.additionalValues.additionalValues && val.additionalValues.additionalValues.sub_Workflow) {
        this.WTemplateStage = val.additionalValues.additionalValues.sub_Workflow.split(',');
        this.stageload();
      } else {
        this.WTemplateStage = [];
      }
    }
  }

  collapseAllClick() {
    this.panelOpenState = !this.panelOpenState;
  }

  getWBSCodes() {
    this._projectService.getProjects(this.projectId, this.memberId).subscribe((data: IProjectMasterViewModel[]) => {
      this.JOBCode = data[0].job_Code;
      this._scheduleDocService.GetWBSCodes({ job_Code: this.JOBCode })
        .subscribe((res: any) => {
          this.wbsList = res;
        });
    });
  }

  setWBSCode(event: EIPAutoCompleteEventModel<IWBSOutputModel>) {
    if (event.value != '-2') {
      this.dciForm.get('wbsCode')?.setValue(event.value);
      this.dciForm.get('wbsCode')?.setValue(event.text);
      this.WBSCode = event.value.toString();
      if (!!this.WBSCode) {
        this._scheduleDocService.GetDeliverableCodes({ job_Code: this.JOBCode, wBS_Code: this.WBSCode })
          .subscribe((res: any) => {
            this.dvcodeList = res;
          });
      }
    }
    else {
      this.dciForm.get('wbsCode')?.setValue(null);
      this.dvcodeList = [];
      this.WBSCode = null;
      this.DeliverableCode = null;
    }
  }

  setDVCode(event: EIPAutoCompleteEventModel<ICPCDocOutputModel>) {
    if (event.value != '-2') {
      this.dciForm.get('dvCode')?.setValue(event.value);
      this.dciForm.get('dvCode')?.setValue(event.text);
      this.DeliverableCode = +event.value
    }
    else {
      this.dciForm.get('dvCode')?.setValue(null);
      this.DeliverableCode = null
    }
  }

  stageload() {
    if (this.selectedDocSetStageDetailsCopy && this.selectedDocSetStageDetailsCopy.length && this.WTemplateStage && this.WTemplateStage.length > 0) {
      let obj: IStageElementDetails[] = [];
      this.selectedDocSetStageDetailsCopy.forEach((val, index) => {
        if (this.WTemplateStage.some((x: number | undefined) => x == val.stage_Id)) {
          val.checked = false;
          obj.push(val)
        }
      });

      this.selectedDocSetStageDetails = obj;
      this.revForm.get('revision')?.setValue('');
      if (this.selectedDocSetStageDetails && this.selectedDocSetStageDetails.length < 1)
        this._notificationService.showToast("Some mismatch in between the selected workflow and document set, please check corresponding configuration.", "Warning");
    }
  }

  onStageChange(event: any, stageEleDetail: IStageElementDetails) {
    if (event.checked) {
      let selDate: any = stageEleDetail.selected_Date;
      if (selDate == null)
        selDate = stageEleDetail.end_Date;
      this.scheduleWFPlanStageDetails.push({ sort_By: stageEleDetail.sort_By, status_Id: stageEleDetail.stage_Id, scheduled_On: selDate });
    }
    else {
      let schWfpStageDetails: IScheduleWFPlanStageDetails = this.scheduleWFPlanStageDetails.filter(x => x.status_Id == stageEleDetail.stage_Id)[0];
      if (!!this.scheduleWFPlanStageDetails) {
        let index: number = this.scheduleWFPlanStageDetails.indexOf(schWfpStageDetails);
        if (index > -1)
          this.scheduleWFPlanStageDetails.splice(index, 1);
      }
    }
  }

  /**
  * Get Element Details (Print Size,Doc Status)
  */
  private getElementDetails(elementName: string, w: IScheduleISODocUploadDetailsModel): string {
    let result!: string;
    switch (elementName) {
      case "Print Size":
        if (this.ProjectElementDetails.filter(d => { return d.deDescription == elementName && d.dedDescription.trim() == w.printSize.trim() }).length <= 0)
          w.errors?.push("Invalid Print Size")
        else
          w.printSize = this.ProjectElementDetails.filter(d => { return d.deDescription == elementName && d.dedDescription.trim() == w.printSize.trim() }).map(h => { return h.dedId })[0].toString();

        result = w.printSize;
        break;
      case "Status":

        if (this.ProjectElementDetails.filter(d => { return d.deDescription == elementName && d.dedShortDescription.trim() == w.category.trim() }).length <= 0)
          w.errors?.push("Invalid Status")
        else
          w.category = this.ProjectElementDetails.filter(d => { return d.deDescription == elementName && d.dedShortDescription.trim() == w.category.trim() }).map(h => { return h.dedId })[0].toString();

        result = w.category;

        break;
      default:
        if (this.projectElements.filter(s => s.elementDescription == elementName).map(h => { return h.isNumbering })[0]) {
          let ded_value = w.docNo.split('-')[this.projectElements.filter(s => s.elementDescription == elementName).map(h => { return h.sortBy })[0] - 1];

          if (this.ProjectElementDetails.filter(d => { return d.deDescription == elementName && d.dedShortDescription.trim() == ded_value.trim() }).length <= 0)
            w.errors?.push("Invalid " + elementName);
          else
            result = this.ProjectElementDetails.filter(d => { return d.deDescription == elementName && d.dedShortDescription.trim() == ded_value.trim() }).map(h => { return h.dedId })[0].toString()
        }
        else {

        }

        break;
    }
    return result;
  }

  private getScheduleDocRevision(x: IScheduleISODocUploadDetailsModel): IScheduleDocRevModel {
    let scheduleDocRevInput: IScheduleDocRevModel = {
      docId: x.rowNo,
      revisionNo: x.revisionNo,
      docStatus: (typeof x.category != 'undefined' && x.category) ? (+x.category) : 0,
      isConfidential: this.getFormValue(this.dciForm, "isConfidential"),
      printSize: (typeof x.printSize != 'undefined' && x.printSize) ? +x.printSize : 0,
      docAuthorizedBy: this.getFormValue(this.revForm, "authorisedBy").memberId,
      revisionCategory: this.getFormValue(this.revForm, "revCategory").revCategoryId,
      qrCodeStatus: this.getFormValue(this.revForm, "qrCodeTag"),
      comments: x.comments,
      reference: this.getFormValue(this.revForm, "reference"),
      noOfSheets: (typeof x.noOfSheets != 'undefined' && x.noOfSheets) ? +x.noOfSheets : 0,
      revisionType: 0,
      docCreatedBy: this.memberId,
      createdBy: this.memberId,
      isActive: true
    }
    return scheduleDocRevInput;
  }

  private getScheduleDocEleDetails(w: IScheduleISODocUploadDetailsModel): IScheduleElementDetails {
    let scheduleDocEleDetails: IScheduleDocElementDetails[] = [];
    let resForm: FormGroup = this.dynamicForm.value;
    this.projectElements.map(async x => {
      let result: IScheduleDocElementDetails;
      if (!x.isNumbering) {
        let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription)?.value;
        result = {
          deId: x.elementId,
          dedId: selectedValue.dedId,
          userId: this.memberId,
          isActive: true,
          docId: w.rowNo
        }
        scheduleDocEleDetails.push(result);
      }
      else {
        result = {
          deId: x.elementId,
          dedId: parseInt((this.getElementDetails(x.elementDescription, w))) ? +this.getElementDetails(x.elementDescription, w) : 0,
          userId: this.memberId,
          isActive: true,
          docId: w.rowNo
        }
        scheduleDocEleDetails.push(result);
      }
    });
    let elmentDetails: IScheduleElementDetails = { elementDetailsMapping: scheduleDocEleDetails };
    return elmentDetails;
  }

  private getScheduleDocWFPlanDetails(x: IScheduleISODocUploadDetailsModel): IScheduleWFPlanDetails {
    let schWFPlandetails: IScheduleWFPlanDetails = {
      doc_Id: x.rowNo,
      revision_No: x.revisionNo,
      docScheduleWFPlanDetails: this.scheduleWFPlanStageDetails,
      is_Active: true,
      userId: this.memberId
    }
    schWFPlandetails.docScheduleWFPlanDetails.map(k => k.scheduled_On = x.scheduled_On.toString());
    return schWFPlandetails;
  }

  private getScheduleRevStageDetails(x: IScheduleISODocUploadDetailsModel): IScheduleDocStageDetails {
    let schDocStageDetails: IScheduleDocStageDetails = {
      doc_Id: x.rowNo,
      revision_No: x.revisionNo,
      docScheduleStageDetails: this.scheduleWFPlanStageDetails.map(x => {
        let stage: IScheduleStageId = {
          stage_Id: x.status_Id
        }
        return stage;
      }),
      stage_Id: this.scheduleWFPlanStageDetails.sort((a, b) => a.sort_By - b.sort_By)[0].status_Id,
      is_Active: true,
      userId: this.memberId
    }
    return schDocStageDetails;
  }

  private getScheduleMHDetails(x: IScheduleISODocUploadDetailsModel): IScheduleMHDetails {
    let eManHours: any = this.getFormValue(this.dciForm, "enggManhours");
    let dManHours: any = this.getFormValue(this.dciForm, "draftingManHours");
    let weightage: any = this.getFormValue(this.dciForm, "weightage");

    let schDocMHDetails: IScheduleMHDetails = {
      doc_Id: x.rowNo,
      e_Man_Hours: !!eManHours ? eManHours : 0,
      d_Man_Hours: !!dManHours ? dManHours : 0,
      weightage: !!weightage ? weightage : 0,
      userId: this.memberId,
      is_Active: true
    }
    return schDocMHDetails;
  }

  private getScheduleDocDetails(x: IScheduleISODocUploadDetailsModel): IScheduleDocDetails {
    let schDocDetails: IScheduleDocDetails = {
      doc_Id: x.rowNo,
      from_Group_Id: this.groupId,
      to_Group_Id: this.getFormValue(this.docScheduleForm, "approvalBy").group_Id,
      revision_No: x.revisionNo,
      schedule_Type: this.getFormValue(this.dciForm, "schType").schType_Id,
      is_Input_Required: this.getFormValue(this.dciForm, "inputRequired").value,
      userId: this.memberId,
      is_Active: true
    }
    return schDocDetails;
  }

  private getScheduleDocWorkflowDetails(x: IScheduleISODocUploadDetailsModel): IScheduleWorkflowDetails {
    let schDocWorkflowDetails: IScheduleWorkflowDetails = {
      doc_Id: x.rowNo,
      userId: this.memberId,
      is_Active: true,
      workflow_Id: this.getFormValue(this.docScheduleForm, "workflow").workflowId,
      revision_No: x.revisionNo
    }
    return schDocWorkflowDetails;
  }

  private getFormValue(form: FormGroup, formControlName: string): any {
    return form.get(formControlName)?.value;
  }

  async saveScheduleDoc() {
    this.saveDocument().then((res: IScheduleDocUploadStatusModel[]) => {
      this.loaderService.isLoading.next(false);
      if (res.length > 0) {
        let dialogRef = this.dialog.open(ScheduleExcelUploadComponent, {
          panelClass: 'mat-dialog-primary',
          data: res,
        });
        this.closeDialog();
      }
      else {
        this._notificationService.showPopup("No Records Found / Invalid File", "Warning");
      }
    }, err => {
      this.loaderService.isLoading.next(false);
      this._notificationService.showToast("Error in upload Template", "Warning");
    })
  }

  /**
  * Save DCI Document
  */
  async saveDocument(): Promise<IScheduleDocUploadStatusModel[]> {

    let result: IScheduleDocUploadStatusModel[] = [];

    if (!this.isDocSetRequired) {
      this.docScheduleForm.get('docSet')?.clearValidators();
      this.docScheduleForm.get('docSet')?.updateValueAndValidity();
      this.docScheduleForm.get('formDocSet')?.clearValidators();
      this.docScheduleForm.get('formDocSet')?.updateValueAndValidity();
    }



    if (!!this.isWBSIntegration) {
      if (!!this.WBSCode) {
        if (!!this.DeliverableCode) {

        } else {
          this._notificationService.showPopup("Kindly select Deliverable Code", "Warning");
          return result;
        }
      }
    }

    if (this.scheduleWFPlanStageDetails && this.scheduleWFPlanStageDetails.length <= 0) {
      this._notificationService.showPopup("Kindly select atleast one WorkFlow Stage", "Warning");
      return result;
    }

    if (this.dynamicForm.form.valid && this.dciForm.valid && this.revForm.valid && this.docScheduleForm.valid) {

      if (this.scheduleWFPlanStageDetails.length > 0) {

        var listIScheduleBulkInsertModel: IScheduleBulkInsertModel[] = [];

        await this.ISOUploadedDocDetails.forEach(async x => {
          if (x.status) {
            let docNo: string = x.docNo;

            let scheduleDocInput: IScheduleDocModel = {
              projectId: this.projectId,
              groupId: this.groupId,
              rowNo: x.rowNo,
              docNo: docNo,
              docSerialNo: null,
              docTitle: x.docTitle,
              userId: this.memberId,
              module: Module.ScheduleDocument
            };
            let docSet: IDocSetModel = this.getFormValue(this.docScheduleForm, "docSet");
            if (!!docSet)

              scheduleDocInput.docSetId = docSet.doc_Set_Id;

            let schBulkInsertModel: IScheduleBulkInsertModel = await {
              isStandardDrawingDocument: false,
              dciMasterDetails: scheduleDocInput,
              dciRevDetails: this.getScheduleDocRevision(x),
              dciSchDetails: this.getScheduleDocDetails(x),
              dciElementDetails: this.getScheduleDocEleDetails(x),
              dciDocScheduleWFPlanDetails: this.getScheduleDocWFPlanDetails(x),
              dciDocSchMHDetails: this.getScheduleMHDetails(x),
              dciDocSchStageDetails: this.getScheduleRevStageDetails(x),
              dciDocSchWorkflowDetails: this.getScheduleDocWorkflowDetails(x)
            }
            x.status = (x.errors?.length == 0);
            if (x.status)
              listIScheduleBulkInsertModel.push(schBulkInsertModel);
            else {
              let docerror: IScheduleDocUploadStatusModel = {
                rowNo: x.rowNo,
                docNo: x.docNo,
                revisionNo: x.revisionNo,
                errors: x.errors,
                status: x.status
              }
              result.push(docerror);
            }
          }
          else {
            let docerrors: IScheduleDocUploadStatusModel = {
              rowNo: x.rowNo,
              docNo: x.docNo,
              revisionNo: x.revisionNo,
              errors: x.errors,
              status: x.status
            }
            result.push(docerrors);
          }
        });

        let tempresult = await this._scheduleDocService.InsertBulkISODCIDocuments(listIScheduleBulkInsertModel).toPromise().then((res: any) => {
          if (res.length > 0)
            result.push.apply(result, res);
        })

      }
      else {
        this._notificationService.showPopup("Kindly select atleast one WorkFlow Stage", "Warning");
      }
    }
    else {
      this.formMarkAsTouched(this.dynamicForm.form);
      this.formMarkAsTouched(this.dciForm);
      this.formMarkAsTouched(this.revForm);
      this.formMarkAsTouched(this.docScheduleForm);
      this._notificationService.showPopup("Kindly fill All Mandatory fields", "Warning");
    }

    return result;
  }

  formMarkAsTouched(form: FormGroup) {
    if (!form.valid)
      Object.keys(form.controls).forEach(key => {
        form.get(key)?.markAsTouched();
      });
  }
}
